import { useEffect, useState } from 'react'

export function usePopoverPosition(
  anchorRef: React.RefObject<HTMLElement>,
  open: boolean
): React.CSSProperties {
  const [style, setStyle] = useState<React.CSSProperties>({ display: 'none' })
  const POPOVER_WIDTH = 224
  useEffect(() => {
    if (open && anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect()
      setStyle({
        position: 'absolute',
        top: 240,
        left: rect.right - POPOVER_WIDTH + 52,
        zIndex: 9999,
        width: POPOVER_WIDTH,
      })
    } else {
      setStyle({ display: 'none' })
    }
  }, [anchorRef, open])
  return style
}
